import { useTheme } from "./theme/useTheme";
import { RoomProvider } from "./room/RoomProvider";
import { Header } from "./components/Header";
import { RoomBar } from "./components/RoomBar";
import { PeerList } from "./components/PeerList";
import { Footer } from "./components/Footer";
import { InteractionManager } from "./components/InteractionManager";

export default function App() {
  const { preference, click } = useTheme();
  return (
    <RoomProvider>
      <div className="flex h-full flex-col">
        <Header preference={preference} onThemeClick={click} />
        <RoomBar />
        <PeerList />
        <Footer />
      </div>
      <InteractionManager />
    </RoomProvider>
  );
}
